import React from 'react';
import { MARQUEE_WORDS } from '../data/mockData';

const ScrollingMarquee = () => {
  const doubledWords = [...MARQUEE_WORDS, ...MARQUEE_WORDS];

  return (
    <section className="bg-[#242326] py-10 md:py-14 overflow-hidden">
      <div className="relative">
        <div className="flex animate-scroll-marquee">
          {doubledWords.map((word, i) => (
            <div key={`${word}-${i}`} className="flex-shrink-0 flex items-center">
              <span className="text-white/80 hover:text-[#83BF42] text-3xl md:text-5xl lg:text-6xl font-light font-['Inter'] whitespace-nowrap transition-colors duration-300 cursor-default">
                {word}
              </span>
              <span className="mx-6 md:mx-10 text-[#83BF42] text-2xl md:text-4xl">{"\u2022"}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScrollingMarquee;
